import React, { useEffect } from "react";
import logoWhite from "../../assets/images/schmodelplain-withR-white.png";
import styles from "./styles.module.css";
import {useRef} from "react-with-hooks";

const Step = ({ children, showLogo= false, centerContent = false, footer }) => {

    const stepContainer = useRef();
    useEffect(() => {
        if (stepContainer.current)
            stepContainer.current.scrollIntoView({ block: 'start' });
    }, []);

    return (
        <div
            ref={stepContainer}
            style={{
                height: "100%",
                width: "100%",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
            className='top-0 left-0 w-full h-full overflow-hidden'
        >

            <div className={styles.step_header_container}>
                {showLogo && <div style={{
                    height: "100%",
                    maxHeight: "70px",
                    display: "flex",
                    alignItems: 'flex-end',
                    paddingBottom: "5px",
                }}>
                    <img src={logoWhite} className={styles.step_logo} alt="img"/>
                </div>}
            </div>
            <div
                style={{
                    width:' 90vw',
                    maxWidth: '400px',
                    flex: 0,
                    position: "relative",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                {children}
            </div>
            <div
                className={styles.step_footer_container}
                style={{
                    flex: (showLogo || centerContent) ? 1 : 2
                }}
            >
                {footer}
            </div>
        </div>
    );
};

export default Step;
